import { Divider } from "antd";
import styled from "styled-components";

export const StyledDivider = styled(Divider).attrs((_props) => ({
   type: (_props)
}))`
   height : auto;
`

